import { BreakpointKey } from "@insite/mobius/utilities/breakpointMediaQueries";
import isBreakpoint from "@toolkit/Framework/Common/Utilities/isBreakpoint";
import { MediaOption } from "@toolkit/Framework/Common/Utilities/mediaQueries";
import { useWindowContext } from "@toolkit/Framework/Components/WindowContext";
import { useCallback } from "react";
import { useTheme } from "styled-components";

function useIsBreakpoint(breakpoint: BreakpointKey, mediaOption?: MediaOption): boolean;
function useIsBreakpoint(): (breakpoint?: BreakpointKey, mediaOption?: MediaOption) => boolean;
function useIsBreakpoint(breakpoint?: BreakpointKey, mediaOption: MediaOption = "only") {
    const theme = useTheme();
    const { currentBreakpoint } = useWindowContext();

    if (breakpoint) {
        return isBreakpoint(theme, currentBreakpoint, breakpoint, mediaOption);
    }

    return useCallback(
        (breakpoint: BreakpointKey, mediaOption: MediaOption = "only") => {
            return isBreakpoint(theme, currentBreakpoint, breakpoint, mediaOption);
        },
        [theme.breakpoints.keys, theme.breakpoints.values, currentBreakpoint],
    );
}

export default useIsBreakpoint;
